module.exports = __webpack_public_path__ + "img/dl006x2.prt.b7e5a1b4.jpg";